import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notification-modal"
export default class extends Controller {
  connect() {
    if (!document.documentElement.hasAttribute("data-turbo-preview")) {
      this.modal = new bootstrap.Modal(this.element)
      this.modal.show()
    }
  }

  disconnect() {
    this.modal.hide()
  }
}
